import React from "react";
import { Col, Row, Card, Image, Container } from "react-bootstrap";

import { Link } from "react-router-dom";

import { Routes } from "../routes";
import NotFoundImage from "../assets/img/common/404.svg";
const NotFound = () => {
  return (
    <main style={{ backgroundColor: "#f4f6f8", width: "100%" }}>
      <section className="vh-100 d-flex align-items-center justify-content-center">
        <Container>
          <Row>
            <Col
              xs={12}
              className="text-center d-flex align-items-center justify-content-center"
            >
              <div>
                <Card.Link as={Link} to={Routes.Dashboard}>
                  <Image src={NotFoundImage} className="img-fluid w-75" />
                </Card.Link>
                <h1 className="text-primary mt-5">
                  Page not <span className="fw-bolder">found</span>
                </h1>
                <p className="lead my-4">
                  Oops! Looks like you followed a bad link. If you think this is
                  a problem with us, please tell us.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default NotFound;
